<div class="wrapper">
    <main class="middle-content">
        <div class="page_title_block">
            <ol class="breadcrumb custom-breadcrumb">
                <li class="breadcrumb-item active">
                    <a routerLink="/therapist">Therapist Management </a>
                </li>
                <li class="breadcrumb-item">Staff Availability</li>
            </ol>
        </div>
        <div class="content-section">
            <div class="outer-box">
                <div class="global-table no-radius p0">
                    <div class="tab-content1">
                        <div class="tab-pane1">
                            <div class="sec_head_new sec_head_new_after">
                                <form [formGroup]="searchForm">
                                    <div class="row">
                                        <div class="col-xl-4 col-lg-4 col-md-4">
                                            <div class="filter_search mb20 width100">
                                                <div class="input-group filter_search_group">
                                                    <input type="text" class="form-control overflow-text"
                                                        formControlName="search" placeholder="Search by name"
                                                        maxlength="60">
                                                    <div class="input-group-append">
                                                        <button class="btn btn_search_group" type="button">
                                                            <img src="assets/img/icon-search.png" alt="Search" />
                                                        </button>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="col-md-3 text-right">
                                            <label>Select date to check slots :</label>
                                        </div>
                                        <div class="col-md-3">
                                            <input type="date" id="subDate" style="border-radius: 5px;max-width: 200px"
                                                class="form-control" formControlName="fromDate">
                                        </div>
                                    </div>
                                </form>
                            </div>
                            <div class="table-responsive">
                                <table class="table table-bordered" aria-describedby="">
                                    <thead>
                                        <tr class="no_wrap_th text-center">
                                            <th class="Sorting-img" scope="col">Time Slots</th>
                                            <th scope="col" class="Sorting-img">Monday</th>
                                            <th scope="col" class="Sorting-img">Tuesday</th>
                                            <th scope="col" class="Sorting-img">Wednesday</th>
                                            <th scope="col" class="Sorting-img">Thursday</th>
                                            <th scope="col" class="Sorting-img">Friday</th>
                                            <th scope="col" class="Sorting-img">Saturday</th>
                                            <th scope="col" class="Sorting-img">Sunday</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr>
                                            <td class="content">
                                                <h5>8-9am</h5>
                                            </td>
                                            <td class="content">Session with John</td>
                                            <td class="content"></td>
                                            <td class="content"></td>
                                            <td class="content"></td>
                                            <td class="content"></td>
                                            <td class="content"></td>
                                            <td class="content"></td>
                                        </tr>
                                        <tr>
                                            <td class="content">
                                                <h5>9-10am</h5>
                                            </td>
                                            <td class="content"></td>
                                            <td class="content">Session with John</td>
                                            <td class="content"></td>
                                            <td class="content"></td>
                                            <td class="content"></td>
                                            <td class="content"></td>
                                            <td class="content"></td>
                                        </tr>
                                        <tr>
                                            <td class="content">
                                                <h5>10-11am</h5>
                                            </td>
                                            <td class="content"></td>
                                            <td class="content"></td>
                                            <td class="content">Session with John</td>
                                            <td class="content"></td>
                                            <td class="content"></td>
                                            <td class="content"></td>
                                            <td class="content"></td>
                                        </tr>
                                        <tr>
                                            <td class="content">
                                                <h5>11-12pm</h5>
                                            </td>
                                            <td class="content" colspan="7">
                                                <h5 class="text-center">Lunch Break</h5>
                                            </td>
                                        </tr>
                                        <tr>
                                            <td class="content">
                                                <h5>12-1pm</h5>
                                            </td>
                                            <td class="content"></td>
                                            <td class="content"></td>
                                            <td class="content"></td>
                                            <td class="content"></td>
                                            <td class="content">Session with John</td>
                                            <td class="content"></td>
                                            <td class="content"></td>
                                        </tr>
                                        <tr>
                                            <td class="content">
                                                <h5>1-2pm</h5>
                                            </td>
                                            <td class="content"></td>
                                            <td class="content"></td>
                                            <td class="content"></td>
                                            <td class="content"></td>
                                            <td class="content"></td>
                                            <td class="content">Session with John</td>
                                            <td class="content"></td>
                                        </tr>
                                        <tr>
                                            <td class="content">
                                                <h5>2-4pm</h5>
                                            </td>
                                            <td class="content"></td>
                                            <td class="content"></td>
                                            <td class="content"></td>
                                            <td class="content"></td>
                                            <td class="content"></td>
                                            <td class="content"></td>
                                            <td class="content">Session with John</td>
                                        </tr>

                                    </tbody>
                                </table>

                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </main>
</div>